import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {Checkbox} from 'shells/checkbox/checkbox';
import {FormField} from 'shells/form/form-field';

type OwnProps = {
    name: string;
    title: string | React.ReactNode;
    isLarge?: boolean;
    isTopAligned?: boolean;
    customCheckboxStyle?: any;
};

type Props = FieldProps & OwnProps;

export function TinyIntroCheckbox({
    title,
    input,
    meta,
    isLarge = true,
    isTopAligned,
    customCheckboxStyle,
    ...restProps
}: Props) {
    return (
        <FormField
            innerId={input.name}
            errorMessage={meta.error && meta.submitFailed ? meta.error : null}
        >
            <Checkbox
                {...input}
                {...restProps}
                checked={input.value}
                label={title}
                hasError={meta.error && meta.submitFailed}
                isLarge={isLarge}
                isTopAligned={isTopAligned}
                customCheckboxStyle={customCheckboxStyle}
            />
        </FormField>
    );
}
